module.exports = __webpack_public_path__ + "static/media/trumpet.94a5eeff.jpg";